module.exports = __webpack_public_path__ + "img/img17.d78ceee1.png";